import { EpisodeCard } from '../Episode';
import type { SearchResult, RecentEpisode } from '../../types';

interface SearchResultsProps {
  results: SearchResult[];
  isLoading: boolean;
  searchTerm: string;
  fallbackImage: string;
  queuedEpisodeIds?: number[];
  onAddToQueue?: (episode: RecentEpisode) => void;
  onNavigate?: (episodeId: number) => void;
  onClose?: () => void;
}

export function SearchResults({
  results,
  isLoading,
  searchTerm,
  fallbackImage,
  queuedEpisodeIds = [],
  onAddToQueue,
  onNavigate,
}: SearchResultsProps) {
  if (isLoading) {
    return (
      <div className="py-12 text-center">
        <div
          className="inline-block w-8 h-8 border-[var(--color-border)]
                      border-t-[var(--color-primary)] rounded-full animate-spin"
          style={{ borderWidth: '3px' }}
        />
        <p className="mt-3 text-sm text-[var(--color-text-muted)]">
          Searching{searchTerm ? ` for "${searchTerm}"` : ''}...
        </p>
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-sm text-[var(--color-text-muted)]">
          No episodes found{searchTerm ? ` for "${searchTerm}"` : ''}
        </p>
      </div>
    );
  }

  // Convert SearchResult to RecentEpisode for queue
  const toRecentEpisode = (episode: SearchResult): RecentEpisode => ({
    episodeid: episode.episodeid,
    episodetitle: episode.episodetitle,
    datetime: episode.datetime,
    image: episode.image,
    showtitle: episode.title,
    showid: episode.showid,
    time_string_format: episode.time_string_format,
  });

  return (
    <div className="mt-3 space-y-2">
      {results.map((episode, index) => (
        <EpisodeCard
          key={episode.episodeid}
          episode={episode}
          fallbackImage={fallbackImage}
          tabIndex={1000 + index}
          isInQueue={queuedEpisodeIds.includes(episode.episodeid)}
          onAddToQueue={onAddToQueue ? () => onAddToQueue(toRecentEpisode(episode)) : undefined}
          onNavigate={onNavigate}
        />
      ))}
    </div>
  );
}
